import { useLimits } from "@/hooks/useLimits";
import { Limits } from "@/types/billing";
import React from "react";
import { Alert, AlertDescription, AlertTitle } from "../ui/alert";
import { AlertCircle, Lock } from "lucide-react";
import { Button } from "../ui/button";
import ShopifyBillingButton from "./ShopifyBillingButton";

type Props = {
  children: React.ReactNode;
  limit: keyof Limits;
};

const LimitBlocker = ({ children, limit }: Props) => {
  const { isLimitReached, featureName, availableMinPlan } = useLimits(limit);

  if (isLimitReached) {
    return (
      <div className="relative">
        <div className="absolute w-[102%] h-[102%] z-50 rounded-xl border top-[-1%] left-[-1%] backdrop-blur-md">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <Alert
              variant="default"
              className="bg-primary rounded-xl text-primary-foreground shadow-xl">
              <AlertCircle className="h-4 w-4" />
              <AlertTitle className="text-lg font-semibold flex items-center gap-2 !pl-0">
                <Lock className="h-4 w-4" /> Upgrade Required
              </AlertTitle>
              <AlertDescription className="mt-2 flex flex-col w-full gap-4 !pl-0">
                <p className="text-sm">
                  The {featureName} feature is only available on the{" "}
                  {availableMinPlan} plan or higher. Upgrade now to unlock this
                  and other cool features!
                </p>
                <ShopifyBillingButton
                  variant="secondary"
                  className="w-full sm:w-auto">
                  Upgrade to {availableMinPlan}
                </ShopifyBillingButton>
              </AlertDescription>
            </Alert>
          </div>
        </div>

        <div className="relative cursor-not-allowed pointer-events-none">
          {children}
        </div>
      </div>
    );
  }

  return children;
};

export default LimitBlocker;
